<!-- 编辑框 -->
<template>
    <el-dialog :title="title" :visible.sync="visible" width="70%" :append-to-body="true" :before-close="handleCloseDialog">
        <el-form :model="pumpForm" size="mini" label-width="90px" ref="pumpRule">
            <el-row :gutter="10">
                <el-col :span="5">
                    <el-form-item label="组名称" prop="name"
                    :rules="[
                        { required: true, message: '请输入组名称', trigger: 'blur' }
                    ]">
                        <el-input v-model="pumpForm.name" placeholder="组名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="集控器"
                    prop="collector_id"
                    :rules="[
                        { required: true, message: '请选择集控器', trigger: 'change' }
                    ]">
                        <el-select v-model="pumpForm.collector_id" style="width:100%;" filterable placeholder="请选择" @change="changeCollector">
                            <el-option
                                v-for="item in collectorList"
                                :key="item.oid"
                                :label="item.dev_name +' : ' + item.dev_serial"
                                :value="item.oid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="PLC"
                    prop="plc_id"
                    :rules="[
                        { required: true, message: '请选择PLC', trigger: 'change' }
                    ]">
                        <el-select v-model="pumpForm.plc_id" style="width:100%;" filterable placeholder="请选择" @change="changePlc">
                            <el-option
                                v-for="item in plcList"
                                :key="item.oid"
                                :label="item.customized_serial + ' : ' + item.terminal_serial"
                                :value="item.oid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item label-width="0">
                        <el-button size="small" @click="addTab">增加分组</el-button>
                    </el-form-item> 
                </el-col>
             </el-row>
            
            <el-tabs v-model="activeName" type="card" closable @tab-remove="removeTab" @tab-click="handleTabClick">
                <el-tab-pane
                    v-for="(item) in TabLists"
                    :key="item.index"
                    :label="item.title"
                    :name="item.index"
                >
                </el-tab-pane>
            </el-tabs>
            <el-form-item
                v-for="(domain, index) in deviceForm[Number(activeName)]"
                :label="'水泵' + (index+1)"
                :key="domain.key">
                <el-row :gutter="10">
                    <el-col :span="10">
                        <el-select v-model="domain.oid" filterable placeholder="请选择变量地址">
                            <el-option
                                v-for="item in varData"
                                :key="item.value"
                                :label="item.var_name+' : '+item.var_Initial_addr"
                                :value="item.oid">
                            </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <el-input v-model="domain.value" placeholder="值"></el-input>
                    </el-col>
                    <el-col :span="6">
                        <el-button type="danger" @click.prevent="removeDomain(domain)">删除</el-button>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item>
                <el-button @click="addCondition">增加条件</el-button>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
const Params = []

export default {
    name: 'cmpLineDialog',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        form: {
            type: Object,
            default: {},
        }
    },
    data () {
        return {
            dialogFormVisible: false,
            deviceForm: JSON.parse(JSON.stringify(Params)),
            pumpForm: {
                collector_id: '',
                plc_id: '',
                name: '',
            },
            activeName: '0',
            TabLists: []
        };
    },

    watch: {
        visible(newVal) {
            if(newVal) {
                this.handleInitData(this.form);
            }
        }
    },

    computed: {
        ...mapGetters(["machine"]),
        title() {
            return '设置水泵组';
        },
        collectorList() {
            return this.machine.collect
        },
        plcList() {
            return this.machine.devices
        },
        varData() {
            return this.machine.var_config
        }
    },

    methods: {
        async handleInitData(Val) {
            if(JSON.stringify(Val) === "{}"){
                // 新增
                this.deviceForm = JSON.parse(JSON.stringify(Params));
                this.TabLists = []
                return
            }
            if(Val.dataset.params !== undefined) {
                // 编辑
                let params = JSON.parse(Val.dataset.params);
                let item
                for( item of params.pumpTab){
                    this.activeName = item.index
                    break;
                }
                //let index = Number(this.activeName)
                await this.getDeviceList(item.collector_id)
                await this.getPlcConfig(item.plc_id)
                // await this.getDeviceList(params.pumpTab[index].collector_id)
                // await this.getPlcConfig(params.pumpTab[index].plc_id)
                this.TabLists = params.pumpTab
                this.deviceForm = params.pumpList
            }
        },
        // 获取表计
        async getDeviceList(collectId) {
            let params = Object.assign({}, { page_num: 1, page_sum: 1000, }, {OID: collectId});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                //if(list.length>0) {
                    this.pumpForm.plc_id = '';
                    
                    this.$store.dispatch('setDevices', list);
                //}
            }
        },
        // 获取变量列表
        async getPlcConfig(terminal_id) {
            
            if(terminal_id === '') 
            {
                let list = []
                this.$store.dispatch('setVarConfig', list);
                return
            }
            let params = {
                terminal_id,
                page_num: 1,
                page_sum: 1000,
            }
            
            let res = await Service.getPlcConfig(params);
            if(res) {
                let list = res.list === null ? [] : res.list;
                this.$store.dispatch('setVarConfig', list);
            }
        },
        changeCollector(val) {
            this.getDeviceList(val)
        },
        changePlc(val) {
            this.getPlcConfig(val);
        },
        handleTabClick(tab, event){
            for(let item of this.TabLists){
                if (item.index==tab.name)
                {
                    this.pumpForm.name = item.title
                    this.pumpForm.collector_id = item.collector_id
                    this.pumpForm.plc_id = item.plc_id
                    this.activeName = item.index
                    this.getPlcConfig(item.plc_id)
                    break
                }
            }
            //this.getPlcConfig(TabLists[tab.name].plc_id)
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认关闭
        handleSave() {
            let data = {
                pumpTab: this.TabLists,
                pumpList: this.deviceForm
            }
            this.$emit("handleCloseDialog", {flag: true, data: data});
        },
        
        addCondition() {
            let index = Number(this.activeName)
            if(this.deviceForm[index] === undefined || this.deviceForm[index] === null) {
                this.deviceForm[index] = []
            }
            let arr = JSON.parse(JSON.stringify(this.deviceForm[index]))
            arr.push({
                oid: '',
                value: '',
                key: Date.now()
            });
            this.$set(this.deviceForm, index, arr)  //  强制更新视图
        },
        removeDomain(item) {
            let type = Number(this.activeName)
            var index = this.deviceForm[type].indexOf(item)
            if (index !== -1) {
                let arr = JSON.parse(JSON.stringify(this.deviceForm[type]))
                arr.splice(index, 1)
                this.$set(this.deviceForm, type, arr)
            }
        },

        addTab() {
            this.$refs['pumpRule'].validate((valid) => {
                if (valid) {
                    //let index = this.TabLists.length + '';
                    let num = 0;
                   for(let item of this.TabLists){
                       if(this.pumpForm.name ==item.title){
                            this.$message({
                                type: 'warning',
                                message: '组别名称已经存在'
                            });
                            return false;
                       }
                       if (parseInt(item.index)>num)
                        {
                            num = parseInt(item.index)
                        }
                   }
                    num = num+1;
                    let index = num+'';
                    this.TabLists.push({
                        index: index,
                        title: this.pumpForm.name,
                        collector_id: this.pumpForm.collector_id,
                        plc_id: this.pumpForm.plc_id,
                    });
                     this.activeName = index;
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },
        removeTab(targetName) {
            let tabs = this.TabLists;
            let activeName = this.activeName;
            if (activeName === targetName) {
                tabs.forEach((tab, index) => {
                    if (tab.index === targetName) {
                    let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                            activeName = nextTab.index;
                        }
                        this.deviceForm[targetName] = [];
                    }
                     
                });
            }
            this.activeName = activeName;
            this.TabLists = tabs.filter(tab => tab.index !== targetName);
        }
    }
}

</script>
<style lang='less' scoped>

</style>